@import "@/scss/use-bootstrap-mixins.scss";

.container {
  .header_text {
    color: $primaryOnBackground !important;
    margin: 0 !important;
    font-size: calc(1.3rem + 0.6vw);
    font-weight: 600 !important;
  }

  .subtitle {
    display: block;
    font-size: 12px;
    font-style: italic;
  }

  .disabled {
    background-color: rgba($color: #000000, $alpha: 0.2) !important;
    opacity: 0.5 !important;
    pointer-events: none !important;
  }

  .upload {
    position: relative;
    background-color: #fff;
    padding: 13px 15px;
    border-radius: 4px !important;
    font-size: 14px;
    border: 1px solid #d0d0d0;
    text-align: center;
    margin-top: 12px;
    margin-bottom: 12px;

    span {
      display: block;
      font-size: 12px;
      font-style: italic;
      max-width: 300px;
      margin: 0 auto;
    }

    input[type="file"] {
      display: block;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
}
